import { GoldenSourceHelper } from "../../app/Switch_Core_React_Standards";

export class CorporateHierarchyRules {
  static canBeRoot(entityId, registry, draft) {
    // Strict Array Check
    if (!entityId || !Array.isArray(registry) || registry.length === 0) return false;

    const record = registry.find(r => GoldenSourceHelper.get(r, "CorporateEntityId") === entityId);
    if (!record) return false;

    const hasSqlParent = !!GoldenSourceHelper.get(record, "ParentEntityId");
    const hasDraftParent = !!draft[entityId];

    return !hasSqlParent && !hasDraftParent;
  }

  static wouldCreateCycle(childId, newParentId, registry, draft) {
    if (!newParentId || !Array.isArray(registry)) return false;

    // Move the helper outside or use an inline find to satisfy ESLint
    let currentId = newParentId;
    const visited = new Set();

    while (currentId) {
      if (currentId === childId) return true;
      if (visited.has(currentId)) break;
      visited.add(currentId);

      const draftParent = draft[currentId];
      if (draftParent !== undefined) {
        currentId = draftParent;
      } else {
        // Use inline find instead of a closure variable
        const record = registry.find(r => GoldenSourceHelper.get(r, "CorporateEntityId") === currentId);
        currentId = record ? GoldenSourceHelper.get(record, "ParentEntityId") : null;
      }
    }
    return false;
  }
}